import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import Animation from "Root/profile/components/Animation";
import H1Font from "Root/profile/components/common/H1Font";
import styles from "./styles.module.scss";
const ResultsAnimation = ({ text, goNext }) => {
    useEffect(() => {
        setTimeout(() => {
            goNext();
        }, 3000);
    }, []);
    return (_jsxs("div", { className: styles.loadingScreen, children: [text && (_jsx("div", { className: `${styles.loadheading}`, children: _jsx(H1Font, { children: text }) })), _jsx(Animation, {})] }));
};
export default ResultsAnimation;
